// Login2 page - similar to Login.js but redirects to MySettings instead of MinProfil
// This is an alternative login flow for users who want different starting settings

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Hook to navigate to different pages
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged } from 'firebase/auth'; // Firebase authentication
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore'; // Firebase database
import { app } from './firebase-config'; // Firebase app configuration

// Initialize Firebase authentication and database
const auth = getAuth(app);
const db = getFirestore(app);

const Login2 = () => {
  const navigate = useNavigate(); // Function to navigate to different pages

  // This effect runs when the component loads
  useEffect(() => {
    // Listen for authentication state changes (when user logs in/out)
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is logged in - set up their data in the database
        const userDocRef = doc(db, 'users', user.uid); // Reference to this user's document
        const userDoc = await getDoc(userDocRef); // Get the user's existing data
        
        // If this is the user's first time logging in, ask for their name
        if (!userDoc.exists()) {
          const userName = prompt("Skriv inn ditt fornavn:"); // Ask user for their first name
          if (userName) {
            // Create a new user document in the database
            await setDoc(userDocRef, {
              name: userName, // User's first name
              points: 0, // Start with 0 points
              attended_events: [] // No events attended yet
            });
          }
        }
        
        // Get the user's data from the database
        const userData = (await getDoc(userDocRef)).data();
        // Save user data to browser's local storage (like a cache on the device)
        localStorage.setItem('userName', userData.name);
        localStorage.setItem('userPoints', userData.points);
        // Navigate to MySettings instead of minprofil
        navigate('/mysettings');
      }
    });

    return () => unsubscribe(); // Clean up when component unmounts
  }, [navigate]);

  // Function called when user clicks the Google sign-in button
  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider(); // Specify that we want to use Google for login
    try {
      // Open Google login popup and sign in the user
      await signInWithPopup(auth, provider);
      console.log('Google sign-in successful');
    } catch (error) {
      console.error('Error with Google sign-in: ', error);
    }
  };

  return (
    <div>
      <h2>Logg inn</h2>
      <button className="button-17" onClick={handleGoogleSignIn}>Logg inn med Google</button>
    </div>
  );
};

export default Login2;